import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field, CccisdSelect, CccisdFieldWrapper } from 'cccisd-formik';
import Modal from 'cccisd-modal';
import Loader from 'cccisd-loader';
import assignmentsQuery from './assignments.graphql';
import formulasQuery from './formulas.graphql';
import { useQuery } from 'cccisd-react-query';
import { client } from 'cccisd-apollo';
import Table from 'cccisd-graphql-table';
import style from './style.css';

const VariablesTable = props => {
    const { initialAssignmentId, initialValues, onChange } = props;

    const { data, isLoading } = useQuery({
        queryKey: ['getAssignmentsAndQueries'],
        queryFn: async () => {
            const res = await client.query({
                query: assignmentsQuery,
                fetchPolicy: 'network-only',
            });

            const assignments = res.data.flows.assignmentList.map(assignment => ({
                id: assignment.assignmentId,
                label: assignment.label,
            }));

            return assignments;
        },
        staleTime: 10 * 60 * 1000,
    });

    if (isLoading) {
        return <Loader loading />;
    }

    const getAssignmentOptions = () => {
        return [
            { value: 0, label: '-- Pick assignment --' },
            ...data.map(item => ({ value: item.id, label: item.label })),
        ];
    };

    return (
        <Formik
            initialValues={{ assignmentId: initialAssignmentId, variableId: 0, ...initialValues }}
            onSubmit={() => {}}
            render={({ values }) => (
                <Form>
                    <div className="d-grid gap-3">
                        <Field
                            name="assignmentId"
                            component={CccisdSelect}
                            label="Assignment"
                            options={getAssignmentOptions()}
                            style={{ width: 'auto' }}
                            wrapperClassName=""
                        />
                        {Number(values.assignmentId) ? (
                            <Table
                                query={formulasQuery}
                                rowKey="variableId"
                                graphqlVariables={{
                                    assignmentId: Number(values.assignmentId),
                                }}
                                filter={values.variableId ? { variableId: values.variableId.toString() } : {}}
                                perPage={10}
                                columns={[
                                    {
                                        name: 'variableId',
                                        label: 'Id',
                                        filter: true,
                                        filterSettings: {
                                            type: 'regex',
                                            preparePattern: value => `^${value}$`,
                                        },
                                    },
                                    {
                                        name: 'reportHeader',
                                        label: 'Variable',
                                        filter: true,
                                    },
                                    {
                                        name: 'label',
                                        label: 'Label',
                                        filter: true,
                                    },
                                ]}
                                onRowClick={row => {
                                    onChange({
                                        variableId: row.variableId,
                                        assignmentId: Number(values.assignmentId),
                                        label: row.reportHeader,
                                    });
                                }}
                                setRowClass={row => (values.variableId === row.variableId ? style.selectedRow : '')}
                            />
                        ) : null}
                    </div>
                </Form>
            )}
        />
    );
};

VariablesTable.propTypes = {
    onChange: PropTypes.func,
    initialValues: PropTypes.object,
    initialAssignmentId: PropTypes.number,
};

const FormulaPicker = props => {
    const { field, form, initialAssignmentId } = props;

    return (
        <CccisdFieldWrapper {...props}>
            <Modal
                trigger={
                    <input
                        name="student"
                        type="text"
                        className="form-select"
                        placeholder="Pick a formula..."
                        value={field.value?.label || ''}
                        onChange={() => {}}
                        style={{ caretColor: 'transparent', cursor: 'pointer' }}
                    />
                }
                title="Pick a formula"
                size="large"
                render={({ closeModal }) => (
                    <VariablesTable
                        initialAssignmentId={initialAssignmentId}
                        initialValues={field.value}
                        onChange={value => {
                            form.setFieldValue(field.name, value);
                            closeModal();
                        }}
                    />
                )}
            />
        </CccisdFieldWrapper>
    );
};

FormulaPicker.propTypes = {
    field: PropTypes.object,
    onChange: PropTypes.func,
    initialAssignmentId: PropTypes.number,
};

export default FormulaPicker;
